import { Icons } from '@agro-club/agroclub-shared'
import { BidTypes } from 'modules/domain/bid/types'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Deal } from 'modules/domain/deal/types'
import { FC } from 'react'
import { generatePath } from 'react-router'
import { AButton } from 'views/components/Analytics'
import BidRoutes from 'views/pages/Bid/routes'

import { isRussia } from 'env'
import { useTranslation } from 'react-i18next'
import AMobileButton from 'views/components/Analytics/AMobileButton'
import { useDealContext } from '../../DealContext'
import { WarehouseMovements } from '../WarehouseMovements'
import { getDealBid } from 'modules/domain/deal/utils'

type BidDetailActionsProps = {
  deal: Deal
  bidType: BidTypes
  dealRefetch: refetchFunc
  isMobile: boolean
}

export const BidDetailActions: FC<BidDetailActionsProps> = ({ dealRefetch, deal, bidType, isMobile }) => {
  const { t } = useTranslation('deal')
  const bid = getDealBid(deal, bidType)
  const { whMovements } = useDealContext()
  const bidContractLink = generatePath(BidRoutes.Details, { id: bid?.id })

  const movementsOnSuccess = () => {
    dealRefetch()
    whMovements.refetch()
  }

  return (
    <>
      {isRussia && bidType === BidTypes.purchase && (
        <WarehouseMovements isMobile={isMobile} refetch={movementsOnSuccess} dealId={deal.id} />
      )}
      {isMobile ? (
        <AMobileButton target="_blank" id="link" color="secondary" Icon={Icons.IconOpen} to={bidContractLink}>
          {t('goToBid')}
        </AMobileButton>
      ) : (
        <AButton
          target="_blank"
          id="link"
          color="secondary"
          background="none"
          Icon={Icons.IconOpen}
          to={bidContractLink}
        />
      )}
    </>
  )
}
